export default __webpack_public_path__ + "static/media/thumbs-up-green.687304f6.svg";